import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "../components/Projects/ProjectCard";
import Particle from "../components/Particle";
import Chatbot from "../components/Chatbot";
import PageTransition from "../components/PageTransition";
import AnimatedSection from "../components/AnimatedSection";
import { motion, AnimatePresence } from "framer-motion";
import { playClickSound, playHoverSound } from "../utils/sound";

import project from "../assets/projects/project.jpeg";
import lift from "../assets/projects/lift.png";
import kickstart from "../assets/projects/kickstart.png";

const PROJECTS_DATA = [
  {
    imgPath: lift,
    title: "Corona Tracker",
    description: "This app, aptly named 'Corona Tracker,' is a powerful and indispensable tool developed with the primary goal of helping individuals stay informed and safe during the ongoing global pandemic. In these challenging times, having access to accurate and up-to-date information is paramount, and this app serves as a reliable companion in navigating the ever-evolving landscape of COVID-19.",
    ghLink: "https://github.com/buntychakraborty/corona-app",
    categories: ["All", "Web App"]
  },
  {
    imgPath: project,
    title: "Text Translator",
    description: "This app is essentially developed to bridge linguistic divides and make communication across languages effortless. Meet the Text Translator, your reliable companion for breaking down language barriers and fostering global connectivity.Text Translator is designed with user-friendliness in mind. Its intuitive interface ensures that even novice users can navigate with ease. Say goodbye to complex menus and confusing options; this app prioritizes simplicity.",
    ghLink: "https://github.com/buntychakraborty/text-translator",
    categories: ["All", "AI/ML", "Web App"]
  },
  {
    imgPath: kickstart,
    title: "Tiny URL Creator",
    description: "This app, aptly named 'Tiny URL Creator,' is a powerful tool designed to simplify and streamline your online experience. Developed with user convenience in mind, it addresses the common challenge of managing lengthy and cumbersome web addresses. In an era where digital information sharing has become the norm, 'Tiny URL Creator' steps in as a handy solution. This app is basically developed to revolutionize the way we share and access online content. It takes those unwieldy, sprawling URLs and compresses them into concise, manageable links that are both easy to share and aesthetically pleasing.",
    ghLink: "https://github.com/buntychakraborty/tiny-url",
    categories: ["All", "Utility", "Web App"]
  }
];

const categories = ["All", "Web App", "AI/ML", "Utility"];

const Projects = () => {
  const [filter, setFilter] = useState("All");

  const filteredProjects = PROJECTS_DATA.filter(p => p.categories.includes(filter));

  return (
    <PageTransition>
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Container fluid className="project-section" style={{ flex: 1 }}>
          <Particle />
          <Container>
            <AnimatedSection direction="up" delay={0.1}>
              <h1 className="project-heading">
                Recent Top <strong className="yellow">Works </strong>
              </h1>
              <p style={{ color: "white", marginBottom: "20px" }}>
                Here are a few projects I've worked on recently.
              </p>
            </AnimatedSection>
            
            {/* Filter Tabs */}
            <AnimatedSection direction="up" delay={0.15}>
              <div className="filter-tabs-container">
                {categories.map((cat) => (
                  <button
                    key={cat}
                    className={`filter-tab ${filter === cat ? "active" : ""}`}
                    onClick={() => {
                      setFilter(cat);
                      playClickSound();
                    }}
                    onMouseEnter={playHoverSound}
                  >
                    {cat}
                    {filter === cat && (
                      <motion.div
                        layoutId="activeTabUnderline"
                        className="active-tab-underline"
                        transition={{ type: "spring", stiffness: 380, damping: 30 }}
                      />
                    )}
                  </button>
                ))}
              </div>
            </AnimatedSection>

            <motion.div layout>
              <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
                <AnimatePresence mode="popLayout">
                  {filteredProjects.map((p) => (
                    <Col key={p.title} md={4} className="project-card">
                      <motion.div
                        layout
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.9 }}
                        transition={{ duration: 0.3 }}
                        style={{ height: "100%" }}
                      >
                        <ProjectCard
                          imgPath={p.imgPath}
                          isBlog={false}
                          title={p.title}
                          description={p.description}
                          ghLink={p.ghLink}
                        />
                      </motion.div>
                    </Col>
                  ))}
                </AnimatePresence>
              </Row>
            </motion.div>
          </Container>
          <Chatbot />
        </Container>
      </div>
    </PageTransition>
  );
}

export default Projects;
